<template>
  <router-view />
</template>

<script>
export default {
  name: 'Vehicle'
}
</script>
